import { useCallback, useRef, useState } from "react";
import { UploadSimple, ImageSquare } from "@phosphor-icons/react";

export default function Dropzone({ onFile, accept = "image/png,image/jpeg,image/webp" }) {
  const [drag, setDrag] = useState(false);
  const inputRef = useRef(null);

  const handleFiles = useCallback(
    (files) => {
      if (!files || files.length === 0) return;
      const f = files[0];
      if (!f.type.startsWith("image/")) return;
      onFile(f);
    },
    [onFile],
  );

  return (
    <div
      data-testid="dropzone"
      onDragOver={(e) => {
        e.preventDefault();
        setDrag(true);
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
      className={`relative flex flex-col items-center justify-center cursor-pointer border-2 border-dashed transition-colors ${
        drag
          ? "border-[var(--accent)] bg-[#fff5f2]"
          : "border-[var(--border)] bg-[var(--bg-2)] hover:bg-white hover:border-black"
      } py-16 md:py-24 px-6 text-center`}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        data-testid="dropzone-input"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <div className="h-12 w-12 border border-black flex items-center justify-center mb-6 bg-white">
        <UploadSimple size={22} weight="bold" />
      </div>
      <div className="font-display font-bold text-xl md:text-2xl tracking-tight">
        Drop an image to vectorize
      </div>
      <div className="mt-2 text-[var(--fg-2)] text-sm">
        PNG · JPG · WEBP · transparent images supported
      </div>
      <div className="mt-6 flex items-center gap-2 micro-label">
        <ImageSquare size={12} weight="bold" /> CLICK OR DRAG
      </div>
    </div>
  );
}
